module.exports = __webpack_public_path__ + "static/media/MaterialButtonEdipos.3b73504b.png";